/**
 * @generated SignedSource<<f2a99252194475852c1c34c81edfed12>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PayseraSettings_settings$data = {
  readonly paysera: {
    readonly acceptUrl: string | null;
    readonly callbackUrl: string | null;
    readonly cancelUrl: string | null;
    readonly currency: string | null;
    readonly lang: string | null;
    readonly password: string | null;
    readonly paytext: string | null;
    readonly projectId: string | null;
  } | null;
  readonly " $fragmentType": "PayseraSettings_settings";
};
export type PayseraSettings_settings$key = {
  readonly " $data"?: PayseraSettings_settings$data;
  readonly " $fragmentSpreads": FragmentRefs<"PayseraSettings_settings">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PayseraSettings_settings",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PayseraSettings",
      "kind": "LinkedField",
      "name": "paysera",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "projectId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lang",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "currency",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "paytext",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "password",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "acceptUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "cancelUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "callbackUrl",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Settings",
  "abstractKey": null
};

(node as any).hash = "9c99daeed80cfa9b1b96a8536f5990e7";

export default node;
